// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1YU0c","footer":"ModalError_footer__1kcAM"};